import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';
import { CleverTapConstents, ConstantData } from 'src/app/services/constants';
import { UtilService } from 'src/app/services/util.service';
import { ValidationService } from 'src/app/services/validation.service';

@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.scss']
})
export class LoginComponent implements OnInit {

  tcVisible: boolean = false;
  phoneNumber: string = '';
  isChecked: boolean = false;
  @Input() isEmailScreen: boolean = false;
  visible: boolean = false;
  errorMsg: string = '';
  iframeSrc: SafeResourceUrl;
  showError: boolean = false;
  showOtp: boolean = false;
  otpErrorMsg: string = '';
  emailOtp: string = '';
  defaultTimer:number = 40;
  timer:number = 40;
  emailInterval:any;
  get editData():{mode:string, phoneNumber:string}| null {
    return sessionStorage.getItem('data')? JSON.parse(sessionStorage.getItem('data') || '{}'):null;
  }
  get emailtimer():string{
    return this.timer.toString().padStart(2,'0');
  }
  input: any;

  formGroup: FormGroup = new FormGroup({
    'phoneNumber': new FormControl('', [Validators.required, this.validators.phoneNumberValidator]),
    'email': new FormControl('', [Validators.required, this.validators.emailValidator]),
  });

  constructor(private util: UtilService, private sanitizer: DomSanitizer, private validators: ValidationService) {
    this.iframeSrc = this.sanitizer.bypassSecurityTrustResourceUrl(this.util.isProduction? ConstantData.tnc_prod:ConstantData.tnc);
  }
  ngOnInit(): void {
    if(this.editData){
      this.formGroup.controls['phoneNumber'].setValue(this.editData.phoneNumber); 
      this.isChecked = true;
    }
        this.util.cleverTapEventCall(CleverTapConstents.registration_Initiated,{});
  }

  redirectToOtp() {
    if (this.isChecked && this.input.length == 10) {
      this.util.login(this.input)
    }
    else if (this.isEmailScreen) {
      this.util.emailVerification(this.formGroup.value['email']).then((res: any) => {
        if (res === 'SUCCESS') {
          this.timer = this.defaultTimer;
          clearInterval(this.emailInterval);
          this.emailInterval = setInterval(()=>{
            this.timer -= 1;
            if(!this.timer){
              clearInterval(this.emailInterval);
            }
          },1000);
          this.showOtp = true;
        }

      });
    }
  }

  handleOtp(event: any) {
    const otpField: any = Array.from(document.querySelectorAll(`.otp-inputs.email-otp-field .cus-input`));
    const index = otpField.findIndex((el: any) => el === event.target);
    this.otpErrorMsg = '';
    if (index < 5 && index !== -1 && event.target.value.length) {
      otpField[index + 1].focus();
    } else if (index > 0 && !event.target.value.length) {
      otpField[index - 1].focus();
    }
    this.emailOtp = otpField.map((el: any) => el.value).join('');


    if (this.emailOtp.length === 6) {
      this.verifyOtpEmail();

    }

  }
  verifyOtpEmail() {
    this.util.handleRequests('put', this.util.getUrl('user_email_verifyOtp'), {
      "emailId": this.formGroup.value['email'],
      "otp": this.emailOtp,
    }).then((res:any)=>{
      this.util.cleverTapEventCall(CleverTapConstents.otp_verfy_suc,{});
       this.util.getToken('');
       this.util.route('home');
    }).catch((err:any)=>{
      this.otpErrorMsg = err.msg;
      this.util.cleverTapEventCall(CleverTapConstents.otp_verfy_fail,{});
    })
  }
  showTandC() {
    this.tcVisible = true;
  }

  openTnc() {
   
    this.visible = true;
  }
  tcChecked(){
    this.util.cleverTapEventCall(CleverTapConstents.tc_accept,{});
  }

  setError() {
    this.showOtp = false;
    this.emailOtp = '';
    this.otpErrorMsg = '';
    const errorObj: any = this.formGroup.controls['email'].errors;
    errorObj && Object.keys(errorObj).forEach((key: string) => {
      switch (key) {
        case 'invalidEmail':
          this.errorMsg = 'Please enter the vaild Email Id.';
          break;
        case 'required':
          this.errorMsg = 'This field is required';
          break;
      }

    });
  }

  onPhoneNumberInput(event: any) {
    this.input = event.target.value;
    const numericInput = this.input.replace(/[^0-9]/g, '');
    this.formGroup.controls['phoneNumber'].setValue(numericInput);
  }
}
